/**
 * Loop over each key/val pair of the given object, calling the callback for
 * each one.
 * @param obj The object to loop over.
 * @param cb The callback to call for each val/key pair.
 */
export default function forEach(obj, cb) {
    for (var key in obj) {
        var val = obj[key];
        cb(key, val);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/utils/forEach.js
// module id = 1207
// module chunks = 0